import { request, getApiBase } from './apiClient';

export const documentApi = {
  // CRUD
  list: (page = 1, limit = 50, search = '', { sort, order, trash } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (search) params.set('search', search);
    if (sort) params.set('sort', sort);
    if (order) params.set('order', order);
    if (trash) params.set('trash', '1');
    return request(`/documents?${params}`);
  },
  get: (id) => request(`/documents/${id}`),
  create: (doc) => request('/documents', {
    method: 'POST',
    body: JSON.stringify(doc),
  }),
  update: (id, doc) => request(`/documents/${id}`, {
    method: 'PUT',
    body: JSON.stringify(doc),
  }),
  delete: (id) => request(`/documents/${id}`, {
    method: 'DELETE',
  }),

  // Pin
  pin: (id) => request(`/documents/${id}/pin`, { method: 'PATCH' }),

  // Duplicate
  duplicate: (id) => request(`/documents/${id}/duplicate`, { method: 'POST' }),

  // Export (.md download)
  exportMd: async (id, title) => {
    const url = `${getApiBase()}/documents/${id}/export`;
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error('Export failed');
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${title || 'untitled'}.md`;
    a.click();
    URL.revokeObjectURL(a.href);
  },

  // Trash
  restore: (id) => request(`/documents/${id}/restore`, { method: 'POST' }),
  permanentDelete: (id) => request(`/documents/${id}/permanent`, { method: 'DELETE' }),
  emptyTrash: () => request('/documents/trash/empty', {
    method: 'DELETE',
    body: JSON.stringify({ confirm: true }),
  }),

  // Merge
  merge: (documentIds, targetId, separator) => request('/documents/merge', {
    method: 'POST',
    body: JSON.stringify({ document_ids: documentIds, target_id: targetId, separator }),
  }),

  // Batch tags
  batchTags: (documentIds, addTags, removeTags) => request('/documents/batch/tags', {
    method: 'POST',
    body: JSON.stringify({ document_ids: documentIds, add_tags: addTags, remove_tags: removeTags }),
  }),

  // Tag management
  tagList: () => request('/tags'),
  tagRename: (oldName, newName) => request('/tags/rename', {
    method: 'PUT',
    body: JSON.stringify({ old_name: oldName, new_name: newName }),
  }),
  tagDelete: (name) => request(`/tags/${encodeURIComponent(name)}`, { method: 'DELETE' }),
  tagMerge: (source, target) => request('/tags/merge', {
    method: 'POST',
    body: JSON.stringify({ source, target }),
  }),
  tagColor: (name, color) => request('/tags/color', {
    method: 'PUT',
    body: JSON.stringify({ name, color }),
  }),

  // Recent / Quick Open
  getRecent: (limit = 100, sort = 'opened') => request(`/documents/recent?limit=${limit}&sort=${sort}`),
  search: (q, limit = 30) => request(`/documents/search?q=${encodeURIComponent(q)}&limit=${limit}`),
  markOpened: (id) => request(`/documents/${id}/open`, { method: 'PATCH' }),

  // Tree structure
  tree: () => request('/documents/tree'),
  move: (documentId, parentId) => request('/documents/move', {
    method: 'PATCH',
    body: JSON.stringify({ document_id: documentId, parent_id: parentId }),
  }),
  children: (id) => request(`/documents/children/${id}`),
  breadcrumb: (id) => request(`/documents/breadcrumb/${id}`),
};
